"use client";

import { useEffect } from "react";
import { selectUserBasicDetails } from "stores/auth/authSlice";
import { useAppDispatch, useAppSelector } from "stores/hooks";
import { markUI } from "stores/ui/uiSlice";
export const FirstRenderLogicNew = () => {
  const currentUser = useAppSelector(selectUserBasicDetails);
  const dispatch = useAppDispatch();

  // reset UI store after change the page
  useEffect(() => {
    return () => {
      dispatch(markUI({
        currentSearchTab: null
      }));
    };
  }, [dispatch]);
  useEffect(() => {
    const timer = setTimeout(() => void (async () => {
      const mixpanelV2Client = (await import("services/mixpanelv2")).mixpanelV2Client;
      const mixpanelV1Client = (await import("services/mixpanel")).mixpanelV1Client;
      mixpanelV1Client.LANDING_PAGE();
      mixpanelV2Client.VIEW_HOME_PAGE({
        theme: "new home page"
      });
    })(), 100);
    return () => timer && clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (currentUser?.userId) {
      void (async () => {
        const mixpanelV2Client = (await import("services/mixpanelv2")).mixpanelV2Client;
        const mixpanelV1Client = (await import("services/mixpanel")).mixpanelV1Client;
        mixpanelV1Client.IDENTIFY(currentUser.userId);
        mixpanelV2Client.IDENTIFY(currentUser.userId);
      })();
    }
  }, [currentUser?.userId]);
  return null;
};